import { EnvelopeStatus, EnvelopeWithStatus } from 'types/Envelope';

export const setEnvelopes = (envelopes: EnvelopeWithStatus[]) => ({
  type: 'SET_ENVELOPES',
  payload: envelopes,
});

export const updateEnvelope = (envelope: EnvelopeWithStatus) => ({
  type: 'UPDATE_ENVELOPE',
  payload: envelope,
});

export const updateEnvelopeStatus = (
  envelopeId: string,
  status: EnvelopeStatus
) => ({
  type: 'UPDATE_ENVELOPE_STATUS',
  payload: { envelopeId, status },
});

export const clearEnvelopes = () => ({
  type: 'CLEAR_ENVELOPES',
});
